import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$lte } from '../query-helpers';

export const MISSING_EDUCATOR_FIELDS = {
  $or: [
    {
      firstName: {
        $equals: ''
      }
    },
    {
      lastName: {
        $equals: ''
      }
    },
    {
      zipCode: {
        $equals: ''
      }
    }
  ]
}

export const MISSING_PARTNER_FIELDS = {
  $or: [
    {
      firstName: {
        $equals: ''
      }
    },
    {
      lastName: {
        $equals: ''
      }
    },
    {
      zipCode: {
        $equals: ''
      }
    },
    {
      ...tags_type_count_$lte(TagTypes.Expertise, 0),
    }
  ]
}

export const MISSING_PARTNER_FIELDS_$AGGREGATIONS = [
  {
    type: 'count',
    alias: 'numberOfExpertiseTags',
    relation: 'tagNodes.tag',
    $where: {
      type: TagTypes.Expertise
    }
  }
]

export const MISSING_PARTNER_FIELDS_$HAVING = {
  $or: {
    firstName: '',
    zipCode: '',
    lastName: '',
    numberOfExpertiseTags: {
      $lte: 0
    }
  }
}
